import { Mj_Badge } from './../mj_badge/mj_badge';
import { Component, Injector, OnInit, ElementRef, ViewChild, ViewChildren } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Tabs, Events } from 'ionic-angular';
import { Util } from '../../app/util';
import { Storage } from '@ionic/storage';
import { Mq_List } from '../mq_list/mq_list';
import { MSteps } from '../msteps/msteps';
import { Confirm } from '../confirm/confirm';
import { Dashboard } from '../dashboard/dashboard';
import { Mj_Sfida } from '../mj_sfida/mj_sfida';
import { Mj_Statistiche } from '../mj_statistiche/mj_statistiche';
import { ThrowStmt } from '@angular/compiler/src/output/output_ast';
import { TranslateService } from '@ngx-translate/core';
import { EthemeProvider } from '../../providers/etheme/etheme';
import { MjsospesiPage } from '../mjsospesi/mjsospesi';
import { ClassifichePage } from '../classifiche/classifiche';
import { Impostazioni } from '../impostazioni/impostazioni';
/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-mj_detail',
  templateUrl: 'mj_detail.html',
})
export class Mj_Detail extends Util {
  pagine: any;
  user: any;
  mj: any;
  fasi: any;
  fasefake: any = {};
  items: any = [];
  //itemExpandHeight = 150;
  itemExpandHeight = [];
  mqs: any = [];
  @ViewChild('allcontent') pagecontent: ElementRef;
  @ViewChild('mytabs') tabs:Tabs;
  modalopened: boolean = false;
  salvati = [];
  ids_mq_saved = [];
  scheda_selezionata = 'percorso';
  constructor(public navCtrl: NavController,public events: Events, public translate: TranslateService, public navParams: NavParams, injector: Injector, loading: LoadingController, public theme: EthemeProvider) {

    // @ViewChild('allcontent') pagecontent: ElementRef;

    super(injector, loading);
    this.modalopened = false;



    
    this.mj = this.navParams.get('mj');
    console.log(this.mj);
    this.events.subscribe('modalopened',(mdopen)=>{
      this.modalopened = mdopen;
    })
  }
  ngOnInit(): void {

  }

  ionViewDidEnter() {
    // console.log(this.pagecontent);
    this.refreshpage(this.mj);
  }

  open_classifiche(){
    this.navCtrl.push(ClassifichePage, { user: this.user }, { animate: false });
  }
  open_impostazioni(){
    this.navCtrl.push(Impostazioni, '', { animate: false });
  }
  refreshpage(mj) {
    this.storage.get('mq_saved_' + this.mj.id+ '_'+this.gs.userx.id).then((ids_mq_savedx) => {
      this.ids_mq_saved = ids_mq_savedx;
      if (this.ids_mq_saved != null && this.ids_mq_saved != undefined) {
        this.ids_mq_saved.forEach(element => {

          this.storage.get('microquest_' + element+ '_'+this.gs.userx.id).then((mq1) => {
            this.salvati.push(mq1);
          })

        });
      }
    })
    this.GetRequest('fasiMicroJourney', mj.id).then(data => {

      this.fasi = data['FaseList'];
      this.fasefake = data['FaseSfida'];
      this.navParams.data['fasefake'] = this.fasefake;

      for (let i = 0; i < this.fasi.length; i++) {
        this.itemExpandHeight[i] = 115;
        /*if (this.fasi[i]['stato'] == 'DA_COMPLETARE') {
          this.open_fase(this.fasi[i], i);
        }
        else*/
        this.fasi[i]['expanded'] = false;
        this.mqs[i] = [];
      }
      // if (data['FaseImpostazioniList'].length > 0) { 
      //   this.fasefake = data['FaseImpostazioniList'][0];
      //   var testin = this.clone(data['FaseImpostazioniList'][0]);
      //   testin.nome = 'Test-In';
      //   var testout = this.clone(data['FaseImpostazioniList'][0]);
      //   testout.nome = 'Test-Out';
      //   this.fasi.unshift(testin);
      //   this.fasi.push(testout);
      //   this.mqs.unshift([]);
      //   this.mqs.push([]);
      //   //console.log(this.mqs);
      // }


      for (let i = 0; i < this.fasi.length; i++) {
        //this.fasi[i]['expanded'] = false;
        if (this.fasi[i]['stato'] == 'DA_COMPLETARE') {
          this.open_fase(this.fasi[i], i);
        }
      }
      /*this.GetRequest('microQuestFase', fasefake.id, false, false).then(data_fake => {

        //console.log(data_fake);
        for(let i =0;i<data_fake['MicroQuestList'].length;i++){
          //console.log(this.mqs);
          let mf = data_fake['MicroQuestList'][i];
          if(mf.tipo == 'Test-In'){
            this.mqs[0].push(mf);
          }
          else if(mf.tipo == 'Test-out'){
            this.mqs[this.mqs.length-1].push(mf);
          }
        }
        //console.log(this.mqs);
      }).catch(err => {console.error(err); this.showBasicAlert('Error', this.etic.en.errorinternet)});*/

    }).catch((e) => {
      //this.navCtrl.push(Mj_Detail,{mj:m});
      console.error(e)
    })
  }

  changeheight(id, h) {
    var x = document.getElementById("ex_" + id);
    x.children[0].setAttribute('style', 'height:' + h + 'px');
    // return;
  }

  // open_quest(m) {
  //   this.navCtrl.push(Mq_List, { mq_list: m });
  // }
  open_fase(m, i) {
    // console.log('emme->', m);
    // console.log('i->', i);
    //console.log('len mqs', this.mqs.length - 1);
    // 
    if (m.stato == 'IN_ATTESA') {
      this.translate.get(['microj.FASEINATTESA', 'microj.NONPUOIACCEDERE']).subscribe(v => {
        this.showBasicAlert(v['microj.FASEINATTESA'], m.statoStr);
      });
      return;
    }

    if (m.expanded == true) {
      m.expanded = false;
    }
    else {
      this.GetRequest('microQuestFase', m.id, true, false).then(data => {
        //this.mqs = data['MicroQuestList'];

        //alert resetStr
        if (data.hasOwnProperty('resetString') && data['resetString'] != null && data['resetString'] != undefined && data['resetString'] != ''){
          this.showBasicAlert(' ', data['resetString']);
          //cancellare lo storage delle mq messe in pausa
          this.svuota_cache_all_mj(this.mj.id);
        }
          

        this.fasi.map((listItem, index) => {

          if (m == listItem) {
            listItem.expanded = !listItem.expanded;

            if (i == 0 && listItem.impostazione == '1') { //testin
              this.mqs[0] = [];
              for (let f = 0; f < data['MicroQuestList'].length; f++) {
                let mf = data['MicroQuestList'][f];
                if (mf.tipo == 'Test-In') {
                  this.mqs[0].push(mf);
                }
              }
            }
            else if (i == this.mqs.length - 1 && listItem.impostazione == '1') { //testout
              //console.log('mi trovo nel test out');
              this.mqs[this.mqs.length - 1] = [];
              for (let r = 0; r < data['MicroQuestList'].length; r++) {
                let mf = data['MicroQuestList'][r];
                if (mf.tipo == 'Test-out') {
                  this.mqs[this.mqs.length - 1].push(mf);
                }
              }
            }
            else {
              this.mqs[index] = data['MicroQuestList'];
              // this.changeheight(i, 92 * data['MicroQuestList'].length); 
            }
            // //console.log(50 * data['MicroQuestList'].length+1);
            //this.itemExpandHeight[i] = 170 * data['MicroQuestList'].length + 1;
            // console.log(this.mqs);
            this.mqs.forEach((tmq) => {
              tmq.forEach((xmq) => {
                if (this.ids_mq_saved && this.ids_mq_saved.indexOf(xmq.id) != -1) {
                  //aggiungo il tentativo in pausa
                  if (xmq.listTentativi.indexOf('n') != -1) {
                    xmq.listTentativi[xmq.listTentativi.indexOf('n')] = 'p';
                  }
                }
              })
            })
          } else {
            listItem.expanded = false;
          }

          return listItem;

        });

      }).catch((e) => {
        //this.navCtrl.push(Mj_Detail,{mj:m});
        console.error(e)
      })
    }
    // });
  }

  expandItem(item) {

    this.items.map((listItem) => {

      if (item == listItem) {
        listItem.expanded = !listItem.expanded;
      } else {
        listItem.expanded = false;
      }

      return listItem;

    });

  }
  open_questionario(m, h, ricom?) {
    this.translate.get(['microj.QUESTIONARIO', 'microj.SICUROINIZIARE', 'microj.SICURORICOMINCIARE']).subscribe(v => {
      if (m.attivo == false) {
        this.showBasicAlert(v['microj.QUESTIONARIO'], m['statoStr']);
        return;
      }
      var event: any;
      var text_popover = v['microj.SICUROINIZIARE'];
      if (ricom == 'ricomincia')
        text_popover = v['microj.SICURORICOMINCIARE'];

      // console.log('mqxxxx', m);
      // console.log('mjxxxx', this.mj);
      if (m.listTentativi.indexOf('p') != -1) {

        this.openMJSospeso(m);

      }
      else {

        this.presentPopover(event, Confirm, text_popover, h + 1).then((data) => {
          //console.log(data);
          if (data == 'confirm') {
            // this.pagecontent.nativeElement.style.display = 'none';
            this.modalopened = true;

            let profileModal = this.modalCtrl.create(MSteps, { mq: m, mj: this.mj }, { showBackdrop: false, enableBackdropDismiss: false, cssClass: this.etheme.theme_selected });
            profileModal.present();
            profileModal.onDidDismiss((r) => {
              // this.pagecontent.nativeElement.style.display = 'block';
              // profileModal = null;
              this.modalopened = false;
              if (r == 'ricomincia') {
                this.open_questionario(m, h, 'ricomincia');
                this.refreshpage(this.mj);
              }
              else
                this.refreshpage(this.mj);
              //console.log(r);
            })
            // this.navCtrl.push(MSteps, { mq: m, mj: this.mj });
          }

        });
      }
    });
  }
  back() {
    //this.navCtrl.push(Dashboard, {});
    this.navCtrl.pop({ animate: false });
  }
  open_btn(page) {
    switch (page) {
      case 'sfide':
        this.navCtrl.push(Mj_Sfida, { 'mj': this.mj, 'fasefake': this.fasefake, 'user': this.user });
        break;
      case 'statistiche':
        this.navCtrl.push(Mj_Statistiche, { 'mj': this.mj });
        break;
      case 'badge':
        this.navCtrl.push(Mj_Badge, { 'mj': this.mj });
        break;
    }
  }
  go_root() {
    this.navCtrl.setRoot(Dashboard);
  }


  openMJSospeso(m) {
    this.modalopened = true;
    let data = { domande: null, risposte: null, mj: null, mq: null };
    this.storage.get('microquest_risposte_' + m.id+ '_'+this.gs.userx.id).then((mq_risposte) => {
      data.risposte = mq_risposte;
      this.storage.get('microquest_domande_' + m.id+ '_'+this.gs.userx.id).then((mq_domande) => {
        data.domande = mq_domande;
        let profileModal = this.modalCtrl.create(MSteps, { issaved: true, mq: m, mj: this.mj, domande: data.domande, risposte: data.risposte }, { showBackdrop: false, enableBackdropDismiss: false, cssClass: this.etheme.theme_selected });
        profileModal.present();
        profileModal.onDidDismiss((r) => {
          // this.svuota_cachex(this.mj.id,m.id);
          this.modalopened = false;
          this.refreshpage(this.mj);

        })
        // this.viewCtrl.dismiss({mq:mqs,mj:this.mj,risposte:this.risposte,domande:this.domande});
      })
    })
  }
  // openMJSospesi() {
  //   const modal = this.modalCtrl.create(MjsospesiPage, { mj: this.mj }, { enableBackdropDismiss: false, cssClass: 'modalfasi' });
  //   modal.onDidDismiss(data => {
  //     console.log(data);
  //     if (data != 'close') {
  //       this.modalopened = true;
  //       console.log({ issaved: true, mq: data.mq, mj: data.mj, domande: data.domande, risposte: data.risposte });
  //       let profileModal = this.modalCtrl.create(MSteps, { issaved: true, mq: data.mq, mj: data.mj, domande: data.domande, risposte: data.risposte }, { showBackdrop: false, enableBackdropDismiss: false, cssClass: this.etheme.theme_selected });
  //       profileModal.present();
  //       profileModal.onDidDismiss((r) => {

  //         this.modalopened = false;
  //         this.refreshpage(this.mj);

  //       })
  //     }
  //   });
  //   modal.present();
  // }
}



// WEBPACK FOOTER //
// ./src/pages/mj_detail/mj_detail.ts